import { InjectionToken } from '@angular/core';
import { FooterLinksFn, SpSidebarLinksFn } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FOOTER_LINKS: InjectionToken<FooterLinksFn> = new InjectionToken<FooterLinksFn>('footerLinks', {
  factory: () => () => []
});
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SP_SIDEBAR_LINKS: InjectionToken<SpSidebarLinksFn> = new InjectionToken<FooterLinksFn>('spSidebarLinks', {
  factory: () => () => []
});
// eslint-disable-next-line @typescript-eslint/naming-convention
export const FOOTER_BRAND_NAME: InjectionToken<string> = new InjectionToken<string>('footerBrandName');
